import { SuppliesSubscriptionOrderInterval } from "@redotech/crdb-enums/product/supplies-subscription-order-interval";
import { SuppliesSubscriptionStatus } from "@redotech/crdb-enums/product/supplies-subscription-status";
import { suppliesSubscriptionIdFormat } from "@redotech/redo-marketplace-id";
import { SortDirection } from "@redotech/redo-views-common/table";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * The merchant-facing row plus the owning merchant, since this view spans every
 * account. Duplicated from the merchant SDK so the two can diverge.
 */
const AdminSuppliesSubscriptionRowSchema_ = z.object({
  id: suppliesSubscriptionIdFormat.schema,
  // Mongo Team name of the owning account, falling back to the account id so a
  // row is never dropped when no team resolves.
  merchantName: z.string(),
  // Mongo Team _id, for linking out to the merchant.
  merchantTeamId: z.string().nullable(),
  productTitle: z.string(),
  productSku: z.string().nullable(),
  productImageUrl: z.string().nullable(),
  quantity: z.number(),
  orderInterval: z.enum(SuppliesSubscriptionOrderInterval),
  orderIntervalFrequency: z.number(),
  // Next scheduled order date.
  nextReorderDate: zExt.plainDate(),
  // Resolved display name of the delivery destination.
  destination: z.string(),
  status: z.enum(SuppliesSubscriptionStatus),
  // Timestamp of the most recent placed order; null if none yet.
  lastOrderDate: z.date().nullable(),
});

export const AdminSuppliesSubscriptionRowSchema: z.ZodType<AdminSuppliesSubscriptionRow> =
  AdminSuppliesSubscriptionRowSchema_;
export interface AdminSuppliesSubscriptionRow extends z.infer<
  typeof AdminSuppliesSubscriptionRowSchema_
> {}

export const getSuppliesSubscriptions = unaryRpc({
  name: "getSuppliesSubscriptions" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z.number(),
    sort: z
      .object({ key: z.string(), direction: createEnum(SortDirection) })
      .nullish(),
  }),
  output: z.object({
    subscriptions: z.array(AdminSuppliesSubscriptionRowSchema),
  }),
});
